import { render, staticRenderFns } from "./DashboardWidgetLoanNotifications.vue?vue&type=template&id=bd58f424&scoped=true&lang=pug&"
import script from "./DashboardWidgetLoanNotifications.vue?vue&type=script&lang=js&"
export * from "./DashboardWidgetLoanNotifications.vue?vue&type=script&lang=js&"
import style0 from "./DashboardWidgetLoanNotifications.vue?vue&type=style&index=0&id=bd58f424&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd58f424",
  null
  
)

/* custom blocks */
import block0 from "./DashboardWidgetLoanNotifications.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports